/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AppointmentDetailSummaryAliases {
  AVATAR_DOCTOR = 'avatar-doctor',
  BREADCRUMB_0 = 'breadcrumb-0',
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_CONFIRM = 'button-confirm',
  BUTTON_EMAIL = 'button-email',
  BUTTON_INSTRUCTIONS = 'button-instructions',
  BUTTON_PRINT = 'button-print',
  BUTTON_QUIZ = 'button-quiz',
  BUTTON_RESCHEDULE = 'button-reschedule',
  BUTTON_RESCHEDULE_MORE = 'button-reschedule-more',
  CARD_APPOINTMENTS_DETAIL_DATE_STATE_0 = 'card-appointments-detail-date-state-0',
  CARD_APPOINTMENTS_DETAIL_LOCATION_1 = 'card-appointments-detail-location-1',
  CARD_APPOINTMENTS_DETAIL_PATIENT_1 = 'card-appointments-detail-patient-1',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_TASK_LIST = 'deck-task-list',
  FETCH_APPOINTMENTS_DETAIL = 'fetch-appointments-detail',
  FETCH_TASK_LIST = 'fetch-task-list',
  FIELD_ADDITIONAL_INFORMATION = 'field-additional-information',
  FIELD_INSURANCE_PLAN = 'field-insurance-plan',
  FIELD_PATIENT_NAME = 'field-patient-name',
  FORM_2 = 'form-2',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  HTML_VIEWER_ADDITIONAL_INFORMATION = 'html-viewer-additional-information',
  LAYOUT_0 = 'layout-0',
  LAYOUT_2 = 'layout-2',
  LAYOUT_4 = 'layout-4',
  LAYOUT_APPOINTMENT_DETAIL = 'layout-appointment-detail',
  LAYOUT_ROOT = 'layout-root',
  MAP_APPOINTMENT_LOCATION_1 = 'map-appointment-location-1',
  MAPPER_ADDITIONAL_INFORMATION = 'mapper-additional-information',
  PANEL_2 = 'panel-2',
  PANEL_4 = 'panel-4',
  PANEL_5 = 'panel-5',
  PANEL_MAP = 'panel-map',
  PANEL_REPEATER = 'Panel-repeater',
  PANEL_TASK_LIST = 'panel-task-list',
  REPEATER_0 = 'repeater-0',
  ROUTE_0 = 'route-0',
  TASK_LIST_SIDE_BAR_CARD = 'task-list-side-bar-card',
  TASK_TITLE = 'task-title',
  TASKS_ALERT_LINK = 'tasks-alert-link',
  TASKS_ALERT_PANEL = 'tasks-alert-panel',
  TASKS_ALERT_TOAST_NOTIFICATION = 'tasks-alert-toast-notification',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
}
export { AppointmentDetailSummaryAliases };
